$(document).ready(() => {
  if ($('#subscription-intention-id').length) {
    App.waiting_list = App.cable.subscriptions.create({ channel: 'SubscriptionIntentionChannel', subscription_intention_id: $('#subscription-intention-id').data('id') }, {
      received(data) {
        try {
          if (data.status === 'success') {
            setTimeout(() => { window.location.href = data.next_step_path; }, 5000);
          } else if (data.status === 'failure') {
            setTimeout(() => {
              $('#subscription-step-1').addClass('d-none');
              $('#subscription-step-1-failure').removeClass('d-none');
            }, 5000);
          } else {
            setTimeout(() => {
              $('#subscription-step-1').addClass('d-none');
              $('#subscription-step-1-error').removeClass('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            $('#subscription-step-1').addClass('d-none');
            $('#subscription-step-1-error').removeClass('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#subscription-step-1').addClass('d-none');
          $('#subscription-step-1-error').removeClass('d-none');
        }, 5000);
        this.uninstall();
      }
    });
  }
});
